// react-router-dom
import { useRoutes } from 'react-router-dom';

// routes
import StudioRoutes from './StudioRoutes';
import AuthenticationRoutes from './AuthenticationRoutes';
import UserRoutes from './UserRoutes';
import OnboardingRoutes from './OnboardingRoutes';
import HostRoutes from './HostRoutes';
import StorefrontRoutes from './StorefrontRoutes';
import PublicRoutes from './PublicRoutes';
import TripGuideRoutes from './TripGuideRoutes';

// ==============================|| ROUTING RENDER ||============================== //

export default function ThemeRoutes() {
  // public routes
  // Order is irrelevant: useRoutes ranks matched branches by specificity, not by
  // array position, so AuthenticationRoutes' `*` catch-all cannot shadow these.
  const routes = [
    StudioRoutes,
    PublicRoutes,
    AuthenticationRoutes,
    OnboardingRoutes,
    HostRoutes,
    StorefrontRoutes,
    UserRoutes,
    TripGuideRoutes
  ];

  return useRoutes(routes);
}
